import LiveKitConsent from './LiveKitConsent';

import TelemedicineContext from '../../context/telemedicine';
import { createFile, removeFile } from '../../services/telemedicine-file';
import { createConsentTerm, getConsentTerm } from '../../services/telemedicine-term';
import { normalizeUploadedFiles } from '../../utils/uploaded-files';

import { DateUtils, showErrorToast, showSuccessToast } from '@amigoapp/doca-react';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const LiveKitConsentContainer = () => {
	const navigate = useNavigate();
	const { telemedicine, updateTelemedicine } = useContext(TelemedicineContext);

	const fileInputRef = useRef();
	const [step, setStep] = useState('termo');
	const [consentTerm, setConsentTerm] = useState(null);
	const [showTerms, setShowTerms] = useState(false);
	const [loading, setLoading] = useState(false);
	const [files, setFiles] = useState([]);
	const [isSubmittingFile, setIsSubmittingFile] = useState(false);

	useEffect(() => {
		getConsentTerm().then(({ data }) => setConsentTerm(data));
	}, []);

	const onOpenTerms = useCallback(event => {
		event.preventDefault();
		setShowTerms(true);
	}, []);

	const onCloseTerms = useCallback(() => setShowTerms(false), []);

	const onProsseguir = useCallback(async () => {
		if (loading) {
			return;
		}

		if (telemedicine.signed_at) {
			setStep('anexos');

			return;
		}

		setLoading(true);

		const { data } = await createConsentTerm();

		if (data) {
			window.socket.emit('telemedicine:patient-connected');
			updateTelemedicine({ signed_at: DateUtils.now() });
			setStep('anexos');
		} else {
			showErrorToast('Não foi possível criar o termo.');
		}

		setLoading(false);
	}, [loading, telemedicine.signed_at, updateTelemedicine]);

	const onBack = useCallback(() => setStep('termo'), []);

	const onSelectFiles = useCallback(async event => {
		const selectedFiles = Array.from(event.target.files || []);

		setIsSubmittingFile(true);

		const { data } = await createFile(event.target.files);

		if (data) {
			setFiles(current => [...current, ...normalizeUploadedFiles(data, selectedFiles)]);
		} else {
			showErrorToast('Não foi possível anexar o arquivo.');
		}

		setIsSubmittingFile(false);
		event.target.value = '';
	}, []);

	const onRemoveFile = useCallback(async id => {
		setFiles(current => current.filter(file => file.id !== id));

		try {
			await removeFile(id);
		} catch (error) { }
	}, []);

	const onContinuar = useCallback(() => {
		if (files.length > 0) {
			showSuccessToast('Anexos enviados com sucesso.');
		}

		navigate('/waiting-room');
	}, [files, navigate]);

	return (
		<LiveKitConsent
			appointmentDate={telemedicine.attendance?.start_date ? telemedicine.attendance.start_date : telemedicine.created_at}
			consentTerm={consentTerm}
			fileInputRef={fileInputRef}
			files={files}
			isSubmittingFile={isSubmittingFile}
			loading={loading}
			provider={telemedicine.user}
			showTerms={showTerms}
			step={step}
			onBack={onBack}
			onCloseTerms={onCloseTerms}
			onContinuar={onContinuar}
			onOpenTerms={onOpenTerms}
			onProsseguir={onProsseguir}
			onRemoveFile={onRemoveFile}
			onSelectFiles={onSelectFiles}
		/>
	);
};

export default LiveKitConsentContainer;
